<template>
  <div>
    <a-row
      :gutter="30"
      style="padding-bottom:20px;"
    >
      <a-radio-group
        v-model="params.type"
        style="margin-left: 16px"
        @change="changeRadio"
      >
        <template v-for="type in types">
          <a-radio-button
            :value="type.value"
            :key="type.value"
          >
            {{ type.text }}
          </a-radio-button>
        </template>
      </a-radio-group>
    </a-row>
    <a-tabs
      v-model="params.tabs"
      @change="tabChange"
      v-if="params.type === 'JOB'"
    >
      <template v-for="tab in tabs">
        <a-tab-pane
          :key="tab.value"
          :tab="tab.label"
        ></a-tab-pane>
      </template>
    </a-tabs>
    <a-tabs
      v-model="params.tabs"
      @change="tabChange"
      v-else
    >
      <template v-for="tab in tabs2">
        <a-tab-pane
          :key="tab.value"
          :tab="tab.label"
        ></a-tab-pane>
      </template>
    </a-tabs>
    <a-row
      :gutter="30"
      style="padding-top:30px;"
    >
      <a-col
        span="8"
        style="margin-bottom:25px;"
      >
        <a-row
          type="flex"
          align="top"
        >
          <a-col
            span="6"
            class="form-label"
          >推荐时间</a-col>
          <a-col span="18">
            <a-range-picker
              style="display:block;width:auto"
              :showTime="true"
              format="YYYY-MM-DD"
              v-model="params.time"
              :disabled-date="disabledDate"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col
        span="8"
        style="margin-bottom:25px;"
      >
        <a-input-group compact>
          <a-select
            v-model="params.main"
            style="width:35%"
          >
            <a-select-option value="company_name">公司名称</a-select-option>
            <a-select-option value="user_name">推荐人姓名</a-select-option>
            <a-select-option value="user_mobile">推荐人手机号</a-select-option>
          </a-select>
          <a-input
            style="width:65%"
            v-model="params.mainValue"
            placeholder="请输入关键字"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col
        span="8"
        style="margin-bottom:25px;"
      >
        <a-row
          type="flex"
          align="top"
        >
          <a-col
            span="6"
            class="form-label"
          >跟进BD</a-col>
          <a-col span="18">
            <a-auto-complete
              allowClear
              style="display:block"
              :dataSource="suggestion"
              @search="handleSearch"
              v-model="params.bd_user_id"
              placeholder="请输入关键字"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
      <a-col
        span="8"
        style="margin-bottom:25px;"
      >
        <a-row
          type="flex"
          align="top"
        >
          <a-col
            span="6"
            class="form-label"
          >推荐人来源</a-col>
          <a-col span="18">
            <a-select
              style="display:block"
              v-model="params.recommend_source"
              placeholder="请选择"
              @change="changeSource"
            >
              <template v-for="(text, key) in sourceData">
                <a-select-option
                  :key="key"
                  :value="text.value"
                >{{ text.label }}</a-select-option>
              </template>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col
        span="8"
        style="margin-bottom:25px;"
        v-if="params.recommend_source == '1'"
      >
        <a-row
          type="flex"
          align="top"
        >
          <a-col
            span="6"
            class="form-label"
          >推荐人类别</a-col>
          <a-col span="18">
            <a-select
              style="display:block"
              v-model="params.vip_level"
              placeholder="请选择"
            >
              <template v-for="(text, key) in vipLevel">
                <a-select-option :key="key">{{ text }}</a-select-option>
              </template>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row
      type="flex"
      justify="space-between"
    >
      <a-col>
        <a-button
          type="primary"
          style="margin-right:12px;padding:0 30px;"
          @click="getData()"
        >筛选</a-button>
        <a-button
          style="margin-right:12px;"
          @click="resetParams"
        >清空筛选条件</a-button>
        <span>共找到 {{ pagination.total }} 条信息</span>
      </a-col>
    </a-row>
    <div
      class="data-table"
      style="padding:30px 0;"
    >
      <a-table
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        @change="getData"
      >
        <template
          slot="post"
          slot-scope="record"
        >
          <!-- 公司名称-->
          <h3>{{ `${record.id}#${record.company_name}` }}</h3>
          <div>
            <span>{{ record.contact_name }}</span>
            <a-divider type="vertical"></a-divider>
            <span>{{ record.contact_tel }}</span>
            <a-divider type="vertical"></a-divider>
            <!-- 微信名-->
            <span>{{ record.job_clue_wechat_number }}</span>
            <a-divider type="vertical"></a-divider>
            <!-- 企业邮箱 -->
            <span>{{ record.job_clue_company_email }}</span>
          </div>
          <div class="flex_jus_start">
            <span>{{ record.province_name }}</span>
            <a-divider type="vertical"></a-divider>
            <a-tooltip
              placement="top"
              v-if="record.note"
            >
              <template slot="title">
                <span>{{ record.note}}</span>
              </template>
              <span
                style="width: 200px;cursor: pointer;"
                class="omit_sigle"
              >{{ record.note}}</span>
            </a-tooltip>
            <span v-else>-</span>
          </div>
          <div>
            <span>提交时间：{{ record.created_at }}</span>
          </div>
        </template>
        <template
          slot="inviter"
          slot-scope="record"
        >
          <h3
            style="color:#ea7b12"
            v-if="params.recommend_source == '1'"
          >
            {{ vipLevel[record.post_user.vip_level] }}
          </h3>
          <h3
            style="color:#35b5fe"
            v-else-if="params.recommend_source == '2'"
          >
            星职场用户
          </h3>
          <div>
            <span>{{ record.post_user.name }}</span>
            <a-divider type="vertical"></a-divider>
            <span>{{ record.post_user.tel }}</span>
          </div>
          <div>
            <span>{{
              record.is_public == "1"
                ? "公开身份 | " + record.user_name
                : "不公开身份"
            }}</span>
          </div>
        </template>
        <template
          slot="bd"
          slot-scope="record"
        >
          <h3 style="color:#35b5fe">状态：{{ record.status_name }}</h3>
          <div>跟进人：{{ record.bd_user.name || "-" }}</div>
          <div>最近状态更新时间：{{ record.updated_at }}</div>
        </template>
        <template
          slot="contact"
          slot-scope="status, record"
        >
          <p>{{ status }}</p>
          <div>{{ record.contact_tel }}</div>
        </template>
        <template
          slot="recommend"
          slot-scope="status, record"
        >
          <p>{{ status }}</p>
          <div>{{ record.post_user.tel }}</div>
        </template>
        <template
          slot="is_public"
          slot-scope="status, record"
        >
          <p>{{ status == 1 ? "公开" : "不公开" }}</p>
          <div v-if="status == 1">{{ record.user_name }}</div>
        </template>
        <template
          slot="action"
          slot-scope="record"
        >
          <div v-show="record.communication_count > 0">
            <a-button
              type="link"
              @click.stop="$refs.markDetailModal.show(record)"
            >查看沟通结果（{{ record.communication_count }}）</a-button>
          </div>
          <div v-show="
              record.status != 'PUBLISH_JOB' &&
                isGranted('clue_manager.job_clue.btn_list_job_clue_add_remark')
            ">
            <a-button
              type="link"
              @click.stop="$refs.markModal.show(record, params.type)"
            >标记沟通结果</a-button>
          </div>
          <a-button
            type="link"
            v-show="
              (record.status == 'SUCCESS' || record.status == 'PUBLISH_JOB') && record.status_name !== '有效线索' &&
                isGranted('clue_manager.job_clue.btn_list_publish_job')
            "
            @click.stop="addJob(record)"
          >{{ params.type === 'JOB' ? '发布职位' : '发布线索' }}</a-button>
        </template>
      </a-table>
    </div>
    <job-mark-modal
      ref="markModal"
      @ok="getData()"
    ></job-mark-modal>
    <Mark-detail-modal ref="markDetailModal"></Mark-detail-modal>
    <!-- <dispatch-bd-modal ref="dispatchBdModal" @ok="getData()"></dispatch-bd-modal> -->
  </div>
</template>
<script>
import JobMarkModal from "./mark-modal";
// import DispatchBdModal from "./dispatch-bd-modal";
import MarkDetailModal from "./mark-detail-modal";
import moment from "moment";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import debounce from "lodash/debounce";
export default {
  name: "JobCash",
  extends: baseComponentVue,
  data () {
    this.handleSearch = debounce(this.handleSearch, 800);
    return {
      types: [],
      tabs: Object.freeze([
        { label: "全部职位", value: "" },
        { label: "新推职位", value: "CREATE" },
        { label: "沟通中", value: "COMMUNICATE" },
        { label: "已获取职位", value: "SUCCESS" },
        { label: "未获取职位", value: "FAILED" },
        { label: "已发布职位", value: "PUBLISH_JOB" }
      ]),
      tabs2: Object.freeze([
        { label: "全部", value: "" },
        { label: "已提交", value: "CREATE" },
        { label: "沟通中", value: "COMMUNICATE" },
        { label: "有效线索", value: "SUCCESS" },
        { label: "无效线索", value: "FAILED" },
      ]),
      vipLevel: ["普通用户", "普通会员", "黄金会员", "白金会员", "黑金会员"],
      sourceData: [
        { value: '1', label: '哥伦布' },
        { value: '2', label: '星职场' }
      ],
      loading: false,
      dataSource: [],
      suggestion: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      params: {
        tabs: this.$route.query.tab || "1",
        type: 'JOB'
      },
      tempType: [],
    };
  },
  components: { JobMarkModal, MarkDetailModal },
  computed: {},
  created () {
    this.getTypes();
    this.resetParams();
    this.setColums();
    this.getData();
  },
  methods: {
    changeRadio (e) {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.getData();
    },
    async getTypes () {
      let res = await Api.cash.getClueTypes();
      this.types = res;
      this.tempType = res;
    },
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },
    changeSource (e) {
      if (e == '2') {
        let arr = [...this.types];
        arr.forEach((item, index) => {
          if (item.value == 'PROFESSION') {
            arr.splice(index, 1)
          }
        })
        this.params.type = 'JOB';
        this.types = arr;
      } else {
        this.types = this.tempType;
      }
      this.getData()
    },
    //BD搜索建议
    async handleSearch (value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.suggestion = arr;
    },
    tabChange (value) {
      this.$router.replace({ path: "/cash/job", query: { tab: value } });
      this.getData();
    },
    rowClick (record) {
      return {
        on: {
          click: () => {
            this.$refs.markDetailModal.show(record);
          }
        }
      };
    },
    setColums () {
      this.columns = [
        {
          title: "职位线索信息",
          key: "id",
          scopedSlots: { customRender: "post" }
        },
        {
          title: "推荐人信息",
          key: "info",
          scopedSlots: { customRender: "inviter" }
        },
        {
          title: "跟进人信息",
          key: "bd",
          scopedSlots: { customRender: "bd" }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" }
        }
      ];
      if (!this.isGranted('clue_manager.job_clue.post_user_visible')) {
        this.columns.splice(1, 1);
      }

    },
    async getData (pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      console.log(this.params);
      let params = {
        [this.params.main]: this.params.mainValue,
        created_start:
          this.params.time[0] &&
          this.params.time[0].format("YYYY-MM-DD HH:mm:ss"),
        created_end:
          this.params.time[1] &&
          this.params.time[1].format("YYYY-MM-DD HH:mm:ss"),
        statuses: this.params.tabs,
        vip_level: this.params.vip_level,
        bd_user_id: this.params.bd_user_id,
        type: this.params.type,
        recommend_source: this.params.recommend_source,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };

      let response = await Api.cash.getJobList(params);
      this.loading = false;
      this.pagination.total = +response.total;
      this.dataSource = response.list;
    },
    resetParams () {
      let params = {
        time: [],
        main: "company_name",
        mainValue: "",
        bd_user_id: "",
        vip_level: "",
        tabs: '',
        type: 'JOB',
        recommend_source: '1'
      };
      this.params = { tabs: this.params.tabs, ...params };
    },
    async checkStatus (item, body, type) {
      try {
        await Api.cash.checkJobStatus({
          type,
          body,
          job_clue_id: item.id
        });
        this.$refs.markModal.close();
        this.getData();
      } catch (e) {
        this.$refs.markModal.distubeLoading();
      }
    },
    addJob (record) {
      this.$router.push({
        path: "/post-edit",
        query: {
          id: record.id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.flex_jus_start {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.omit_sigle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
